/**
 * A scene is what is behind the regions: a background and, maybe, the avatar. `stage` is the stage of the pack or of
 * Settings (stage/catalog.ts): its background, the avatar standing in the box. Hiding the avatar means changing scene.
 */
import type { FaceKind } from '../avatar/face';
import type { Box } from '../layout/geometry';

export interface SceneDefinition {
  id: string;
  /** CSS background of the whole canvas; under the stage's background image when `stage` is set. */
  background: string;
  /** The stage's background shows here (Settings, else the pack's). */
  stage?: boolean;
  /** Where the avatar is drawn, in canvas pixels, if this scene has one. */
  avatarBox?: Box;
  /** The face it asks for (avatar/face.ts); Settings may choose another, and particles stand in for a missing one. */
  avatar?: FaceKind;
}

/** Where the avatar stands: a 720×1280 frame at 0.75 scale, the right half at eye height (the MuseTalk plate's place). */
export const AVATAR_BOX: Box = { x: 540, y: 61.75, width: 540, height: 960 };

export const BUILTIN_SCENES: readonly SceneDefinition[] = [
  {
    id: 'stage',
    background: 'var(--scene-plain, var(--color-surface-2))',
    stage: true,
    avatarBox: AVATAR_BOX,
    avatar: 'musetalk',
  },
  {
    id: 'lowpoly',
    background: 'var(--scene-plain, var(--color-surface-2))',
    stage: true,
    avatarBox: { x: 0, y: 0, width: 1080, height: 1920 },
    avatar: 'lowpoly',
  },
  { id: 'text', background: 'var(--scene-text-background)' },
  { id: 'plain', background: 'var(--scene-plain, var(--color-surface-2))' },
];
